import React from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error }) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Container
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        paddingTop: "30px",
      }}
      maxWidth="sm"
    >
      <Paper elevation={3}>
        <Box mt={3} mb={1} mx={2}>
          <Typography variant="h4" component="h1" gutterBottom>
            Something went wrong
          </Typography>
          <Typography variant="subtitle1" component="h2" gutterBottom>
            An unexpected error occurred. Please try refreshing the page.
          </Typography>
        </Box>
        <Divider />
        <Box mx={2} my={2}>
          <Typography variant="body2" color="error" gutterBottom>
            <strong>Exception details:</strong>
          </Typography>
          <Paper
            variant="outlined"
            sx={{ background: "#f8d7da", padding: 2, marginBottom: 2 }}
          >
            <Typography variant="body2" color="error.main">
              {error?.message}
            </Typography>
            {error?.stack && (
              <Box mt={1}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{ whiteSpace: "pre-wrap" }}
                >
                  {error.stack}
                </Typography>
              </Box>
            )}
          </Paper>
          <Grid container spacing={2}>
            <Grid item>
              <Button
                sx={{ textTransform: "capitalize" }}
                variant="contained"
                color="primary"
                onClick={handleRefresh}
              >
                Refresh Page
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  );
};

export default ErrorFallback;
